import { c as _c } from "react/compiler-runtime";
import { IcoWarning24 } from '@onefootprint/icons';
import { Button, LoadingSpinner } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type InitViewProps = {
  isError: boolean;
  retryLimitExceeded: boolean;
  onRetry: () => void;
};
const InitView = t0 => {
  const $ = _c(13);
  const {
    isError,
    retryLimitExceeded,
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.non-id-doc.pages.init"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  if (isError) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <IcoWarning24 color="error" />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== retryLimitExceeded || $[3] !== t) {
      t3 = <div className="flex flex-col items-center justify-center gap-2">{t2}{retryLimitExceeded ? <div className="text-body-2 text-secondary text-center">{t(_temp)}</div> : <div className="text-body-2 text-secondary text-center">{t(_temp2)}</div>}</div>;
      $[2] = retryLimitExceeded;
      $[3] = t;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== onRetry || $[6] !== retryLimitExceeded || $[7] !== t) {
      t4 = !retryLimitExceeded && <Button onClick={onRetry}>{t(_temp3)}</Button>;
      $[5] = onRetry;
      $[6] = retryLimitExceeded;
      $[7] = t;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
      t5 = <div className="flex h-full flex-col justify-center items-center gap-4 py-4 px-6">{t3}{t4}</div>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t2;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-center h-full min-h-[var(--loading-container-min-height)] justify-center text-center"><LoadingSpinner size="xlarge" /></div>;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
export default InitView;
function _temp($) {
  return $["retry-limit-exceeded"];
}
function _temp2($_0) {
  return $_0.error;
}
function _temp3($_1) {
  return $_1["try-again"];
}